module.exports = __webpack_public_path__ + "img/xw-004.af9dd030.jpg";